import styled, { useTheme } from 'styled-components';
import Banners from '../../components/Banners';
import Rewards from '../../components/Rewards';
import {
  Heading3Text,
  Heading4Text,
  ParagraphMediumText,
  ParagraphSmallText,
} from '../../components/Texts';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import Button from '../../components/Button';
import RewardsTable from './Table';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../redux/slices/modals';
import { useGetCurrentUserReferralsQuery } from '../../redux/api/authorized/auth';
import { selectPrivyToken } from '../../redux/slices/auth';
import { formatUSDEnsure2Digits } from '../../common/currency';
import ScrollRestore from '../../components/ScrollRestore';
import { usePrivy } from '@privy-io/react-auth';
import useCustomLogin from '../../hooks/useCustomLogin';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 12px;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
  }
`;

const InnerInfoContainer = styled.div`
  flex-direction: row;
  display: flex;
  gap: 8px;
`;

const Info = styled.div`
  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 16px;
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
    padding: 12px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 4px;
  }
`;

const StyledHeading4Text = styled(Heading4Text)`
  font-weight: 600;
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 24px;
  }
`;

const RewardsView = () => {
  const dispatch = useDispatch();
  const { login } = useCustomLogin();
  const { user } = usePrivy();
  const privyToken = useSelector(selectPrivyToken);
  const { data: referrals, isLoading: isLoadingReferrals } =
    useGetCurrentUserReferralsQuery({
      skip: !privyToken,
    });

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();
  return (
    <Container>
      <ScrollRestore />
      <TitleContainer>
        <StyledHeading4Text style={{ color: theme.text.title }}>
          Rewards
        </StyledHeading4Text>
        <ParagraphSmallText>
          <b>Refer Friends. Earn Crypto Together.</b> <br />
          Earn 50% commission on every trade accross Deks of your friends.
        </ParagraphSmallText>
      </TitleContainer>
      <InfoContainer>
        {isMobile ? (
          <InnerInfoContainer>
            <Info>
              <ParagraphMediumText style={{ fontWeight: 600 }}>
                Referral Earnings
              </ParagraphMediumText>
              <Heading3Text style={{ color: theme.status.success.primary }}>
                {formatUSDEnsure2Digits(referrals?.totalReferralEarnings || 0)}
              </Heading3Text>
            </Info>
            <Info>
              <ParagraphMediumText style={{ fontWeight: 600 }}>
                Referred Users
              </ParagraphMediumText>
              <Heading3Text style={{ color: theme.status.success.primary }}>
                {referrals?.referredUsersCount || 0}
              </Heading3Text>
            </Info>
          </InnerInfoContainer>
        ) : (
          <>
            <Info>
              <ParagraphMediumText style={{ fontWeight: 600 }}>
                Referral Earnings
              </ParagraphMediumText>
              <Heading3Text style={{ color: theme.status.success.primary }}>
                {formatUSDEnsure2Digits(referrals?.totalReferralEarnings || 0)}
              </Heading3Text>
            </Info>
            <Info>
              <ParagraphMediumText style={{ fontWeight: 600 }}>
                Referred Users
              </ParagraphMediumText>
              <Heading3Text style={{ color: theme.status.success.primary }}>
                {referrals?.referredUsersCount || 0}
              </Heading3Text>
            </Info>
          </>
        )}
        <Info>
          <ParagraphMediumText style={{ fontWeight: 600 }}>
            Share and start earning
          </ParagraphMediumText>
          <Button
            onClick={() => {
              if (!user) {
                login();
              } else {
                dispatch(openModal({ name: 'referrals' }));
              }
            }}
          >
            SHARE REFERRAL LINK
          </Button>
        </Info>
      </InfoContainer>
      <RewardsTable
        data={referrals?.history || []}
        isLoading={isLoadingReferrals}
      />
      <Heading4Text style={{ marginTop: 10, color: theme.text.title }}>
        How to Earn More
      </Heading4Text>
      <Rewards />
    </Container>
  );
};

export default RewardsView;
